import React from "react";
import { Lock, Zap } from "lucide-react";
import { formatINR, INCENTIVE_TX_TYPES, PURE_COMMISSION_TX_TYPES } from "../lib/format";

// Two-box wallet breakdown: Incentives (monthly milestone bonus — locked
// until the cycle ends) vs Commission (agreement fee, deposit-protection %,
// referral bonuses, brokerage — always withdrawable immediately). Same
// underlying wallet/balance as today; this only categorizes it for display.
export default function IncentiveCommissionBoxes({ wallet }) {
  if (!wallet) return null;

  const transactions = wallet.transactions || [];
  const incentivesEarned = transactions
    .filter((t) => INCENTIVE_TX_TYPES.includes(t.type))
    .reduce((sum, t) => sum + (t.amount_paise || 0), 0);
  const commissionEarned = transactions
    .filter((t) => PURE_COMMISSION_TX_TYPES.includes(t.type))
    .reduce((sum, t) => sum + (t.amount_paise || 0), 0);
  const lockedIncentives = wallet.locked_balance_paise || 0;

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div className="card-base p-5">
        <div className="flex items-center gap-2 mb-1">
          <Lock className="h-4 w-4 text-amber-500" />
          <div className="text-xs text-gray-500 uppercase tracking-wide">Incentives</div>
        </div>
        <div className="text-2xl font-bold font-display">{formatINR(incentivesEarned)}</div>
        <div className="text-xs text-gray-500 mt-1">
          {lockedIncentives > 0
            ? `${formatINR(lockedIncentives)} locked — withdrawable once this cycle ends`
            : "Monthly milestone bonus — withdrawable once each cycle ends"}
        </div>
      </div>
      <div className="card-base p-5">
        <div className="flex items-center gap-2 mb-1">
          <Zap className="h-4 w-4 text-emerald-500" />
          <div className="text-xs text-gray-500 uppercase tracking-wide">Commission</div>
        </div>
        <div className="text-2xl font-bold font-display text-emerald-600">{formatINR(commissionEarned)}</div>
        <div className="text-xs text-gray-500 mt-1">Agreement fee, deposit protection &amp; referral bonuses — withdrawable anytime</div>
      </div>
    </div>
  );
}
